import ContentLayout from "../../component/ContentLayout";
import { AgGridReact } from "ag-grid-react";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment/moment";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { FaRegCopy } from "react-icons/fa6";

const PrizeFullfillment = () => {
  const { setError } = useContext(Context);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [prizeFullFillData, setPrizeFullFillData] = useState<any>(null);

  const [searchBy, setSearchBy] = useState("name");
  const [searchByValue, setSearchByValue] = useState("");
  const [searchByFromDate, setSearchByFromDate] = useState("");
  const [searchByToDate, setSearchByToDate] = useState("");

  const [searchByData, setSearchByData] = useState([]);

  const getPrizeFullFillData = async (isSearchBy = true) => {
    setLoading(true);

    const searchByDate =
      searchBy === "date" || searchBy === "prizefull_date"
        ? searchBy === "date"
          ? `&start_date=${searchByFromDate}&end_date=${searchByToDate}`
          : `&prizefull_start_date=${searchByFromDate}&prizefull_end_date=${searchByToDate}`
        : `${searchBy}=${searchByValue}`;
    const url = isSearchBy
      ? `/omw/admin/get_social_media_contest_winners?page=${pageNumber}&limit=${pageSize}&${searchByDate}`
      : `/omw/admin/get_social_media_contest_winners?page=${pageNumber}&limit=${pageSize}`;

    await axios({
      URL: url,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setPrizeFullFillData(data);
        setTotalRecords(res?.data?.pagination?.totalCount);
        setTotalPages(res?.data?.pagination?.totalPages);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPrizeFullFillData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, pageSize]);

  const onPageChange = (action: string, step: number) => {
    if (action === "prev") {
      if (pageNumber - step > 0) {
        setPageNumber(pageNumber - step);
      } else {
        setPageNumber(1);
      }
    } else {
      const totalPages = Math.ceil(totalRecords / pageSize);
      if (pageNumber + step <= totalPages) {
        setPageNumber(pageNumber + step);
      } else {
        setPageNumber(totalPages);
      }
    }
  };

  const updatePrizeStatus = async (id: any, value: string) => {
    setLoading(true);
    const data = {
      status: value,
    };
    await axios({
      URL: `/omw/admin/update_prize_status/${id}`,
      method: "PUT",
      data,
    })
      .then((res) => {
        getPrizeFullFillData();
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const getDataSerachBy = async (key?: any) => {
    setSearchBy(key);
    setSearchByData([]);
    setPageNumber(1);
    if (key === "prize" || key === "contest" || key === "fullfilled_status") {
      setSearchByFromDate("");
      setSearchByToDate("");
      setSearchByValue("");

      if (key === "fullfilled_status") {
        const status: any = [
          {
            id: "Pending",
            name: "Pending",
          },
          {
            id: "accept",
            name: "Accept",
          },
          {
            id: "reject",
            name: "Reject",
          },
        ];
        setSearchByData(status);
      } else {
        const searchingBy =
          key === "contest"
            ? `reward=false&content=true`
            : `reward=true&content=false`;
        await axios({
          URL: `/omw/admin/get_content_and_prize_list?${searchingBy}`,
          method: "GET",
        })
          .then((res) => {
            setSearchByData(res?.data?.data);
          })
          .catch((err) => setError(err?.response?.data?.message))
          .finally(() => setLoading(false));
      }
    } else if (key === "phone" || key === "email" || key === "name") {
      setSearchByFromDate("");
      setSearchByToDate("");
      setSearchByValue("");
      setPageNumber(1);
    } else {
      setSearchByValue("");
      setPageNumber(1);
    }
  };

  const [colDefs] = useState<any>([
    {
      field: "fullname",
      headerName: "Name",
      minWidth: 250,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center gap-2"}
            onClick={() => navigator.clipboard.writeText(param.value)}
          >
            <p>{param.value || "-"}</p>
            <FaRegCopy
              className={"cursor-pointer"}
              onClick={() => navigator.clipboard.writeText(param.value)}
            />
          </div>
        );
      },
    },
    // { field: "created_by", headerName: "Created By" },
    {
      field: "claim_dt",
      headerName: "Date",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex flex-col items-center justify-center"}>
            <p className={"p-0 text-sm"}>
              {moment(param.value).format("MM-DD-yyyy")}
            </p>
            <p className={"p-0 text-sm font-bold"}>
              {moment(param.value).format("hh:mm A")}
            </p>
          </div>
        );
      },
    },
    {
      field: "contest_name",
      headerName: "Contests Name",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex flex-col items-center justify-center"}>
            <p className={"p-0 text-sm font-bold"}>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "prize_name",
      headerName: "Prize Name",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex flex-col items-center justify-center"}>
            <p className={"p-0 text-sm font-bold"}>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center justify-start gap-2"}
            onClick={() => navigator.clipboard.writeText(param.value)}
          >
            <p>{param.value || "-"}</p>
            <FaRegCopy
              className={"cursor-pointer"}
              onClick={() => navigator.clipboard.writeText(param.value)}
            />
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center justify-start gap-2"}
            onClick={() => navigator.clipboard.writeText(param.value)}
          >
            <p>{param.value || "-"}</p>
            <FaRegCopy
              className={"cursor-pointer"}
              onClick={() => navigator.clipboard.writeText(param.value)}
            />
          </div>
        );
      },
    },
    {
      field: "state",
      headerName: "State",
      minWidth: 50,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-center"}>
            <p>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "fulfillment_dt",
      headerName: "Time Fulfilled",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex flex-col items-center justify-center"}>
            <p className={"p-0 text-sm"}>
              {param?.value
                ? moment(param.value).format("MM-DD-yyyy hh:mm A")
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      field: "prize_fulfillment_status",
      headerName: "Reward Status",
      minWidth: 80,
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["reject", "pending", "confirm"],
        valueListGap: 10,
      },
      editable: false,
    },
    {
      field: "prize_fulfillment_status",
      headerName: "Action",
      minWidth: 80,
      maxWidth: 80,
      cellRenderer: (param: any) => {
        return param?.value === "accept" || param?.value === "reject" ? (
          "-"
        ) : (
          <div className={"flex flex-row items-center justify-center gap-1"}>
            <button
              className={" cursor-pointer disabled:cursor-not-allowed"}
              onClick={() => {
                updatePrizeStatus(param?.data?.id, "accept");
              }}
            >
              <CheckIcon className={"text-green"} />
            </button>
            <button
              className={"cursor-pointer disabled:cursor-not-allowed"}
              onClick={() => {
                updatePrizeStatus(param?.data?.id, "reject");
              }}
            >
              <CloseIcon className={"text-red-600"} />
            </button>
          </div>
        );
      },
    },
  ]);

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Prize Fulfillment</p>
      <div className={"flex w-full justify-end my-3 px-3"}>
        <div
          className={
            "gap-2 lg:flex lg:items-center grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:w-auto w-full"
          }
        >
          <div className={"flex gap-1 justify-center items-center w-[350px]"}>
            <label
              htmlFor="search"
              className={"text-primary whitespace-nowrap"}
            >
              Search By
            </label>
            <select
              name="search"
              id="search"
              className={`border border-primary text-primary border-solid py-2 w-full rounded-md`}
              value={searchBy}
              onChange={(e) => {
                getDataSerachBy(e.target.value);
              }}
            >
              <option value={"contest"}>Contests</option>
              <option value={"prize"}>Prize</option>
              <option value={"date"}>Date</option>
              <option value={"prizefull_date"}>Prizefull Date</option>
              <option value={"fullfilled_status"}>Fulfilled Status</option>
              <option value={"phone"}>Phone</option>
              <option value={"email"}>Email</option>
              <option value={"name"}>Name</option>
            </select>
          </div>
          {searchBy === "date" || searchBy === "prizefull_date" ? (
            <div className={"flex items-center gap-2 w-[500px]"}>
              <label
                htmlFor="from_date"
                className={"text-primary whitespace-nowrap"}
              >
                From Date
              </label>
              <input
                className={
                  "border border-primary border-solid p-2 text-primary placeholder-primary w-full rounded-md"
                }
                name={"from_date"}
                type={"date"}
                placeholder={"From Date"}
                value={searchByFromDate}
                onChange={(e) => setSearchByFromDate(e.target.value)}
              />
              <label
                htmlFor="to_date"
                className={"text-primary whitespace-nowrap"}
              >
                To Date
              </label>
              <input
                className={
                  "border border-primary border-solid p-2 text-primary placeholder-primary w-full rounded-md"
                }
                type={"date"}
                name={"to_date"}
                placeholder={"To Date"}
                value={searchByToDate}
                onChange={(e) => setSearchByToDate(e.target.value)}
              />
            </div>
          ) : searchBy === "name" ||
            searchBy === "phone" ||
            searchBy === "email" ? (
            <input
              className={
                "border border-primary border-solid p-2 text-primary placeholder-primary rounded-md w-[350px]"
              }
              type={"text"}
              placeholder={"Type here"}
              value={searchByValue}
              onChange={(e) => setSearchByValue(e.target.value)}
            />
          ) : (
            <div>
              <select
                className={`border border-primary text-primary border-solid py-2 rounded-md w-[350px]`}
                value={searchByValue}
                onChange={(e) => setSearchByValue(e.target.value)}
              >
                <option value={""}>select</option>
                {searchByData.map((item: any) => {
                  return <option value={item.id}>{item.name}</option>;
                })}
              </select>
            </div>
          )}

          <div className={"flex flex-row gap-2 w-[230px]"}>
            <button
              className={
                "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] disabled:cursor-not-allowed"
              }
              onClick={() => (searchBy ? getPrizeFullFillData() : null)}
              disabled={loading}
            >
              Search
            </button>
            <button
              className={
                "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] whitespace-nowrap disabled:cursor-not-allowed"
              }
              onClick={() => {
                setSearchBy("name");
                setSearchByData([]);
                setSearchByValue("");
                setSearchByFromDate("");
                setSearchByToDate("");
                setPageNumber(1);
                getPrizeFullFillData(false);
              }}
              disabled={loading}
            >
              Clear All
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white w-full mt-8">
        <div
          className="ag-theme-quartz w-full" // applying the Data Grid theme
          style={{ height: 500 }} // the Data Grid will fill the size of the parent container
        >
          <AgGridReact
            loading={loading}
            rowData={prizeFullFillData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            // pagination={pagination}
            // paginationPageSize={pageSize}
            // paginationPageSizeSelector={paginationPageSizeSelector}
            suppressRowClickSelection={true}
            // onPaginationChanged={(event) => onPageChange(event)}
            // onCellValueChanged={(e) => updatePrizeStatus(e.data.id, e.newValue)}
          />
        </div>
        <div
          className={
            "my-2 px-2 w-full flex justify-end flex-col sm:flex-row gap-4 sm:gap-10"
          }
        >
          <div>
            <label htmlFor="pages">Page size:</label>
            <select
              name="page"
              id="page"
              className={
                "w-[100px] border-b border-primary border-solid p-2 outline-none"
              }
              value={pageSize}
              onChange={(e) => {
                setPageNumber(1);
                setPageSize(+e.target.value);
              }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
          <div className={"flex gap-2 justify-center items-center"}>
            <KeyboardDoubleArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() => setPageNumber(1)}
            />
            <KeyboardArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() =>
                pageNumber === 0 ? null : onPageChange("prev", 1)
              }
            />
            <p>
              Page {pageNumber} of {Math.ceil(totalRecords / pageSize)}
            </p>
            <KeyboardArrowRightIcon
              className={`text-lg cursor-pointer`}
              onClick={() =>
                pageNumber === Math.ceil(totalRecords / pageSize)
                  ? null
                  : onPageChange("next", 1)
              }
            />
            <KeyboardDoubleArrowRightIcon
              className={"text-lg cursor-pointer"}
              onClick={() => setPageNumber(totalPages)}
            />
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};
export default PrizeFullfillment;
